import { useTheme, useMediaQuery } from '@mui/material';

const useIsMobile = () => {
  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up('md'));
  return isMobile;
}

export default useIsMobile;